import { useEffect } from 'react'
import smoothscrollPolyfill from 'smoothscroll-polyfill'

export const useSmoothScrollPolyfill = () => {
    useEffect(() => {
        // polyfill the scroll* (intoView, By, & To) api for the DOM
        smoothscrollPolyfill.polyfill()
    }, [])
}
